import React from 'react'
import Avatar from '../Avatar/Avatar'
import Carousel from 'nuka-carousel'
import styles from './Testimonial.module.css'

const Testimonial = props => {
  return (
    <div className={styles.testimonial}>
      <div className={styles.inner}>
        <div className={styles.photo}>
          <Avatar photo={props.photo} />
        </div>
        <div className={styles.body}>
          <p>{props.body}</p>
          <p className={styles.meta}>
            - {props.name}, {props.company}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Testimonial



// WEBPACK FOOTER //
// ./src/components/Testimonial/Testimonial.js